import { formatCurrencyAdvanced } from '@erp/shared-utils';

/**
 * A unit cost as the vendor quotes it: always four decimals. Contract prices
 * carry four ($1.0193), and rounding them to $1.02 makes the unit cost disagree
 * with the line total it multiplies into; a fixed scale also keeps a column of
 * unit costs lined up on the decimal point. Totals stay at cents.
 */
export function formatUnitCost(value: number): string {
  return formatCurrencyAdvanced(value, 'USD', {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  });
}

/** A share such as 0.586 as a whole percentage, "59%". */
export function formatWholePercent(fraction: number): string {
  return new Intl.NumberFormat(undefined, {
    style: 'percent',
    maximumFractionDigits: 0,
  }).format(fraction);
}
